import React from 'react';
import styled from 'styled-components';

const StyledTimerUnit = styled.div`
  font-weight: bold;

  > .time {
    font-size: 16px;
  }

  > .name {
    font-size: 8px;
    opacity: 0.5;
  }
`;

const TimerUnit = ({ duration, name }: { duration: number; name: string }): React.ReactElement => (
  <StyledTimerUnit className='entry text-center'>
    <div className='time font-weight-bold'>{`${Math.round(duration)}`.padStart(2, '0')}</div>
    <div className='name mt-8px text-uppercase'>{name}</div>
  </StyledTimerUnit>
);

const StyledSeparator = styled.div`
  font-size: 18px;
  margin-bottom: 20px;
`;

const Separator = (): React.ReactElement => (
  <StyledSeparator className='font-weight-bold mx-4px'>:</StyledSeparator>
);

export const Timer = ({
  days,
  hours,
  minutes,
  seconds
}: {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}): React.ReactElement => (
  <div>
    <div className='d-flex align-items-center'>
      <TimerUnit name={days > 1 ? 'days' : 'day'} duration={days} />
      <Separator />
      <TimerUnit name={hours > 1 ? 'hours' : 'hour'} duration={hours} />
      <Separator />
      <TimerUnit name={minutes > 1 ? 'minutes' : 'minute'} duration={minutes} />
      <Separator />
      <TimerUnit name={seconds > 1 ? 'seconds' : 'second'} duration={seconds} />
    </div>
  </div>
);
